<template>
  <div class="index-act-item">
    <div class="act-tt">
      <div class="lf">
        <span
          class="barge barge-grad"
        >{{formData.promotionType==1?'按件打折':formData.promotionType==2?'按金额打折':formData.promotionType==3?'按金额满减':'按件满减'}}</span>
        <p>{{formData.startTime}}</p>
      </div>
      <span
        class="rt barge barge-nostarted"
        :class="{'barge-close':formData.statusString=='已结束','barge-success':formData.statusString=='进行中'}"
      >{{formData.statusString}}</span>
    </div>
    <div class="act-goods">
      <div
      class="goods-item"
      v-for="(item, index) in formData.discountGoodsImageList"
      :key="index"
      @click="onJumpToGoodsDetailClick(formData)"
      >
        <img class="good" :src="item.imageUrl" />
        <img class="logo" src="@/assets/image/wenwen2@2x.png" v-if="item.goodType == 2" />
      </div>
    </div>
    <div class="act-disct">
      <span
        class="barge barge-danger"
        v-for="(item,index) in formData.discountLadderSettingStringList"
        :key="index"
      >{{item}}</span>
    </div>
    <div class="act-desc">
      <img class="desc-tl" src="../../../assets/image/time@2x.png" />
      <div class="desc-ct">
        <div>
          剩余
          <van-count-down
            style="display: inline-block;"
            :time="setTime(formData.endTime)"
            format="DD 天 HH 时 mm 分"
          />结束
        </div>
        <p>{{formData.name}}</p>
      </div>
    </div>
    <div class="act-tltp">
      <div class="omit" @click.stop="onClickOmit">
        <img src="../../../assets/image/dian@2x.png" />
        <ul class="tltp" v-if="show" @click.stop>
          <li @click="btnClick('trial')">试算</li>
          <!-- <li @click="btnClick('manage')" v-if="formData.timeStatus != 3">管理活动</li> -->
          <li @click="btnClick('delete')" v-if="formData.timeStatus == 3">删除</li>
          <li @click="btnClick('edit')"  v-if="formData.status ==1 || formData.timeStatus != 3">修改活动</li>
          <li @click="btnClick('start')" v-if="formData.status ==1 || formData.status ==3">发布活动</li>
          <li @click="btnClick('stop')"  v-if="formData.status ==2 && formData.timeStatus != 3">暂停活动</li>
          <li @click="btnClick('close')" v-if="formData.status !=4 && formData.timeStatus != 3">结束活动</li>

          <li @click="btnClick('copy')" >复制活动</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/common";
import { Dialog } from 'vant';
export default {
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.HiddenClick)
  },
  methods: {
    onClickOmit() {
      console.log(this.branchStatusItem);
      if (this.branchStatusItem == 'FREEZE') {
        Dialog.confirm({
          message: '店铺已冻结，无法操作',
          confirmButtonText: '我知道了',
          confirmButtonColor: '#007AFF',
          showCancelButton: false
        })
        return
      }
      this.show = !this.show;
    },
    HiddenClick() {
      this.show = false
    },
    closeRefresh() {
      this.$emit("closeRefresh");
      this.onClickOmit();
    },
    onJumpToGoodsDetailClick(formData) {
      if (this.branchStatusItem == 'FREEZE') {
        Dialog.confirm({
          message: '店铺已冻结，无法操作',
          confirmButtonText: '我知道了',
          confirmButtonColor: '#007AFF',
          showCancelButton: false
        })
        return
      }
      let url = window.location.origin+'/h5user/addedGoods?id='+formData.id+'&status='+formData.status
      if(this.beeType == 2 && this.brandData.shopId) {
        url = url + "&brandId=" + this.brandData.shopId;
      }
      utils.jumpToNewPage({
        url,
        noTitle: '1'
      })
    },
    btnClick(item) {
      if (this.branchStatusItem == 'FREEZE') {
        Dialog.confirm({
          message: '店铺已冻结，无法操作',
          confirmButtonText: '我知道了',
          confirmButtonColor: '#007AFF',
          showCancelButton: false
        })
        return
      }
      let url = "";
      switch (item) {
        case "delete":
          url = "/order/bees/discountActivity/delete/" + this.formData.id;
          this.getQueryServer(url, "post");
          break;
        case "stop":
          url = "/order/bees/discountActivity/suspend/" + this.formData.id;
          this.getQueryServer(url, "put");
          break;
        case "close":
          this.$dialog.confirm({
            title: '结束活动',
            message: '确定结束活动吗？结束后无法恢复，请谨慎操作',
            showCancelButton: true,
            confirmButtonText: '确认结束',
            cancelButtonText: '再看看'
          }).then(()=>{
            console.log(234);
            url = "/order/bees/discountActivity/finish/" + this.formData.id;
            this.getQueryServer(url, "put");
          }).catch(()=>{

          })
          // url = "/order/bees/discountActivity/finish/" + this.formData.id;
          // this.getQueryServer(url, "put");
          break;
        case "start":
          this.getStartCallback()
          break;
        case "trial":
          let url = window.location.origin +"/h5user/discount_trial?type=1&id="+this.formData.id
          if(this.beeType == 2 && this.brandData.shopId) {
            url = url + "&brandId=" + this.brandData.shopId;
          }
          utils.jumpToNewPage({url});
          break;
        case "edit":
          url = window.location.origin + "/h5user/discount?id=" + this.formData.id
          if(this.beeType == 2 && this.brandData.shopId) {
            url = url + "&brandId=" + this.brandData.shopId;
          }
          utils.jumpToNewPage({ url });
          break;
          case "copy":
            url = window.location.origin + "/h5user/discount?id=" + this.formData.id+'&type=copy'
            if(this.beeType == 2 && this.brandData.shopId) {
              url = url + "&brandId=" + this.brandData.shopId;
            }
            utils.jumpToNewPage({ url });
          break;
        case "manage":
          utils.jumpToNewPage({
            url:
              window.location.origin +
              "/h5user/discount?id=" +
              this.formData.id,
          });
          break;
        default:
          break;
      }
      this.onClickOmit();
    },
    getQueryServer(url, method) {
      this.http({
        url: url,
        method: method,
      })
        .then((rps) => {
          if (rps.code == 200) {
            this.$toast("操作成功！");
            this.closeRefresh();
          }
        })
        .catch((err) => {});
    },
    setTime(time) {
      let ts = Date.parse(new Date(time.replace(/\-/g, "/")));
      let st = Date.parse(new Date());
      return ts - st;
    },
    getStartCallback() {
      let url = "/order/bees/discountActivity/publish/" + this.formData.id;
      if(!this.formData.involvedGoodCount && !this.formData.discountActivityType) {
        this.$dialog.confirm({
          title: '提示',
          message: '请您添加活动商品',
          showCancelButton: true,
          confirmButtonText: '去添加'
        }).then(()=>{
          this.$router.push({
            name: 'addedGoods',
            query: {
                id: this.formData.id,
                status: this.formData.status,
            }
          })
          // utils.jumpToNewPage({
          //   url:
          //     window.location.origin +
          //     "/h5user/addedGoods?id=" +
          //     this.formData.id,
          //   noTitle: '1'
          // });
        })
      } else if(this.formData.discountActivityType) {
        this.$dialog.confirm({
          title: '提示',
          message: '是否已检查品类活动商品',
          showCancelButton: true,
          confirmButtonText: '去检查',
          cancelButtonText: '已检查，马上发布'
        }).then(()=>{
          utils.jumpToNewPage({
            url:
              window.location.origin +
              "/h5user/addedGoods?id=" +
              this.formData.id + 
              '&status=' + this.formData.status,
            noTitle: '1'
          });
        }).catch(()=>{
          this.getQueryServer(url, "put");
        })
      } else if(this.formData.involvedGoodCount && !this.formData.discountActivityType) {
        this.$dialog.confirm({
          title: '发布活动',
          message: '是否已经细心核对所有已发布的预置商品和问问商品的价格，避免在活动发布后造成损失',
          showCancelButton: true,
          confirmButtonText: '确认无误',
          cancelButtonText: '再看看'
        }).then(()=>{
          this.getQueryServer(url, "put");
        }).catch(()=>{
          utils.jumpToNewPage({
            url:
              window.location.origin +
              "/h5user/addedGoods?id=" +
              this.formData.id + 
              '&status=' + this.formData.status,
            noTitle: '1'
          });
        })
      }
    }
  },

  props: {
     beeType: {
      default: 1,
      type: Number,
    },
    formData: {
      default: function () {
        return {};
      },
      type: Object,
    },
    beeType: {
      default: 1,
      type: Number,
    },
    brandData: {
      default: function () {
        return {};
      },
      type: Object,
    },
    branchStatusItem: {
      default: 'OPENING',
      type: String,
    }
  },
};
</script>

<style lang="less" scoped>
.index-act-item {
  font-size: 24px;
  background-color: #fff;
  padding: 0 30px 15px;
  margin: 20px 20px 0;
  .act-goods {
    display: flex;
    margin-top: 20px;
    .goods-item {
      position: relative;
      margin-left: 20px;
      &:first-child {
        margin-left: 0;
      }
      .good {
        width: 150px;
        height: 150px;
        vertical-align: bottom;
      }
      .logo {
        width: 57px;
        height: 30px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
  .act-tt {
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;

    .lf {
      display: flex;
      align-items: center;

      p {
        margin-left: 20px;
        color: #999;
      }
    }
  }
  .act-disct {
    margin: 20px 0;
    span{
      width: auto !important;
      min-width: 180px;
      padding: 0 20px;
      margin-top: 20px;
      margin-right: 20px;
      box-sizing: border-box;
    }
  }
  .act-desc {
    display: flex;
    padding: 25px 30px 18px;
    background-color: #f7f7f7;
    border-radius: 10px;
    .desc-tl {
      width: 40px;
      height: 40px;
    }
    .desc-ct {
      margin-left: 10px;
      div {
        display: block;
        height: 40px;
        font-size: 24px;
        font-weight: 500;
        line-height: 40px;
        color: #666;
      }
      p {
        font-size: 20px;
        line-height: 29px;
        color: #999;
        margin-top: 5px;
      }
    }
  }
  .act-tltp {
    height: 55px;
    line-height: 55px;
    position: relative;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .omit {
      width: 44px;
      height: 44px;
      position: absolute;
      top: 0;
      right: 0;
      text-align: center;
      font-size: 40px;
    }
    .tltp {
      position: absolute;
      top: 0;
      right: 40px;
      display: flex;
      height: 55px;
      background-image: url(../../../assets/image/tooltip_four@2x.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-right: 20px;
      font-size: 20px;

      li {
        width: 110px;
        text-align: center;
        color: #fff;
        border-right: 1px solid #999;
        &:last-child{
          border-right: 0px solid #999;
        }
      }
    }

    span {
      font-size: 40px;
    }
  }

  .barge {
    display: inline-block;
    width: 140px;
    height: 40px;
    line-height: 40px;
    border-radius: 10px;
    border: 2px solid #999;
    color: #999;

    font-size: 24px;
    text-align: center;
    box-sizing: border-box;
    &.barge-danger {
      width: 180px;
      height: 50px;
      line-height: 50px;
      font-weight: 500;
      color: #ed3939;
      background-color: #ffe7e6;
      border-color: #ffe7e6;
    }
    &.barge-grad {
      color: #fff;
      padding-top: 3px;
      background: linear-gradient(90deg, #ff8200, #ff1414);
      border: none;
    }
    &.barge-nostarted {
      width: 110px;
      color: #fff;
      padding-top: 3px;
      background: #fd9090;
      border: none;
    }
    &.barge-success {
      width: 110px;
      padding-top: 3px;
      color: #fff;
      background: #a9e864;
      border: none;
    }
    &.barge-close {
      background: #f2f2f2;
      color: #999999;
      padding-top: 3px;
      width: 110px;
      border: none;
    }
  }
}
</style>